import React, { useState, useEffect } from "react";
import { Card, Button, Form } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { useFormik } from "formik";
import * as yup from "yup";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import { useSelector, shallowEqual } from "react-redux";
import * as apiCentri from "../../../../api/centri";
import { icons, roles, isAgente } from "../../../../config/config";

const phoneRegExp = /^((\+[1-9]{1,4}[ -]?)|(\([0-9]{2,3}\)[ -]?)|([0-9]{2,4})[ -]?)*?[0-9]{3,4}[ -]?[0-9]{3,4}$/;
const validationSchema = yup.object({
  nome: yup
    .string("Inserire un nome valido")
    .required("Inserire un nome valido")
    .min(3, "Minimo tre caratteri")
    .max(50, "Massimo cinquanta caratteri"),
  indirizzo: yup
    .string("Inserire un indirizzo valido")
    .required("Inserire un indirizzo valido")
    .min(3, "Minimo tre caratteri")
    .max(255, "Massimo 255 caratteri"),
  cap: yup
    .string("Inserire un CAP valido")
    .required("Inserire un CAP valido")
    .min(5, "Minimo tre caratteri")
    .max(5, "Massimo 255 caratteri"),
  citta: yup
    .string("Inserire una città valido")
    .required("Inserire una città valido")
    .min(2, "Minimo tre caratteri")
    .max(255, "Massimo 255 caratteri"),
  provincia: yup
    .string("Inserire una provincia valida")
    .required("Inserire una provincia valida")
    .min(2, "Minimo 2 caratteri")
    .max(2, "Massimo 2 caratteri"),
  // email: yup
  //   .string()
  //   .email("Inserire un'email valida")
  //   .required("Inserire un'email valida")
  //   .min(3, "Minimo 3 caratteri")
  //   .max(50, "Massimo 50 caratteri"),
  recapito: yup
    .string()
    .required("Inserire un numero di telefono valido")
    .min(9, "Minimo 9 cifre")
    .max(15, "Massimo 15 cifre")
    .matches(phoneRegExp, "Solo numeri"),
  tipo: yup
    .string("Inserire un tipo valido")
    .required("Inserire un tipo di centro valido")
    .min(2, "Minimo 2 caratteri")
    .max(50, "Massimo cinquanta caratteri"),
});

const actionsMessages = {
  new: "Crea",
  edit: "Modifica",
  reset: "Reset",
};

const formFields = {
  nome: {
    label: "Nome",
    placeholder: "Nome...",
  },
  indirizzo: {
    label: "Indirizzo",
    placeholder: "Indirizzo...",
  },
  cap: {
    label: "CAP",
    placeholder: "CAP",
  },
  citta: {
    label: "Città",
    placeholder: "Città...",
  },
  provincia: {
    label: "Provincia",
    placeholder: "Provincia...",
  },
  recapito: {
    label: "Recapito",
    placeholder: "Recapito...",
  },
  tipo: {
    label: "Tipo",
    placeholder: "Studio centro Privato, ASL, Centro Convenzionato...",
  },
};

const Toolbar = ({ submitCallback, closeCallback, resetCallback, loading, alreadyExisting, ...props }) => {
  return (
    <div {...props}>
      <Button disabled={loading} onClick={submitCallback} className="my-1 ml-2 d-inline-flex align-items-center">
        <span className="svg-icon svg-icon-md svg-icon-light-primary">
          <SVG src={toAbsoluteUrl(icons.ok)} />
        </span>
        {alreadyExisting ? actionsMessages.edit : actionsMessages.new}
      </Button>
      <Button disabled={loading} onClick={resetCallback} variant="secondary" className="my-1 ml-2 d-inline-flex align-items-center">
        <span className="svg-icon svg-icon-md svg-icon-secondary">
          <SVG src={toAbsoluteUrl(icons.reset)} />
        </span>
        {actionsMessages.reset}
      </Button>
      <Button onClick={closeCallback} variant="secondary" className="my-1 ml-2 d-inline-flex align-items-center">
        <span className="svg-icon svg-icon-md svg-icon-secondary">
          <SVG src={toAbsoluteUrl(icons.go_back)} />
        </span>
        Centri
      </Button>
    </div>
  );
};

export const EditNewCentro = (props) => {
  const user = useSelector((state) => state.auth.user, shallowEqual);
  const [loading, setLoading] = useState(false);
  const initialState = {
    id_centro: false,
    nome: "",
    indirizzo: "",
    cap: "",
    citta: "",
    provincia: "",
    recapito: "",
    tipo: "",
  };
  const alreadyExisting = props.centro !== false;
  if (alreadyExisting) {
    const centro = {
      ...props.centro,
    };
    Object.assign(initialState, centro);
  }

  const formik = useFormik({
    initialValues: initialState,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      console.log(values);
      setLoading(true);
      const result = {
        ...values,
        id_centro: alreadyExisting ? initialState.id_centro : "",
      };

      apiCentri
        .add(props.token, result)
        .then(() => setLoading(false))
        .then(() => props.triggerServerUpdate())
        .then(() => props.hideEditPage());
    },
  });

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  return (
    <Card className="card-custom gutter-b">
      <Card.Header className="border-0 py-5 row">
        <Card.Title className="float-left col-auto">
          <h3 className="font-weight-bolder text-dark">
            {alreadyExisting ? actionsMessages.edit + " centro" : actionsMessages.new + " centro"}
          </h3>
        </Card.Title>
        <Toolbar
          submitCallback={formik.handleSubmit}
          resetCallback={formik.handleReset}
          closeCallback={props.hideEditPage}
          loading={loading}
          alreadyExisting={alreadyExisting}
          className="float-right col-auto"
        />
      </Card.Header>
      <Card.Body className="pt-0">
        <Form className="row">
          <Form.Group className="col-xl-6 col-lg-6 col-sm-12">
            <Form.Label className="col-12">{formFields["nome"].label}</Form.Label>
            <Form.Control
              type="text"
              name="nome"
              placeholder={formFields["nome"].placeholder}
              className={getInputClasses("nome")}
              {...formik.getFieldProps("nome")}
            />
            {formik.touched["nome"] && formik.errors["nome"] ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors["nome"]}</div>
              </div>
            ) : null}
          </Form.Group>

          <Form.Group className="col-xl-6 col-lg-6 col-sm-12">
            <Form.Label className="col-12">{formFields["tipo"].label}</Form.Label>
            <Form.Control
              type="text"
              name="tipo"
              placeholder={formFields["tipo"].placeholder}
              className={getInputClasses("tipo")}
              {...formik.getFieldProps("tipo")}
            />
            {formik.touched["tipo"] && formik.errors["tipo"] ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors["tipo"]}</div>
              </div>
            ) : null}
          </Form.Group>

          <Form.Group className="col-xl-6 col-lg-6 col-sm-12">
            <Form.Label className="col-12">{formFields["indirizzo"].label}</Form.Label>
            <Form.Control
              type="text"
              name="indirizzo"
              placeholder={formFields["indirizzo"].placeholder}
              className={getInputClasses("indirizzo")}
              {...formik.getFieldProps("indirizzo")}
            />
            {formik.touched["indirizzo"] && formik.errors["indirizzo"] ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors["indirizzo"]}</div>
              </div>
            ) : null}
          </Form.Group>

          <Form.Group className="col-xl-6 col-lg-6 col-sm-12">
            <Form.Label className="col-12">{formFields["citta"].label}</Form.Label>
            <Form.Control
              type="text"
              name="citta"
              placeholder={formFields["citta"].placeholder}
              className={getInputClasses("citta")}
              {...formik.getFieldProps("citta")}
            />
            {formik.touched["citta"] && formik.errors["citta"] ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors["citta"]}</div>
              </div>
            ) : null}
          </Form.Group>

          <Form.Group className="col-xl-6 col-lg-6 col-sm-12">
            <Form.Label className="col-12">{formFields["cap"].label}</Form.Label>
            <Form.Control
              type="text"
              name="cap"
              placeholder={formFields["cap"].placeholder}
              className={getInputClasses("cap")}
              {...formik.getFieldProps("cap")}
            />
            {formik.touched["cap"] && formik.errors["cap"] ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors["cap"]}</div>
              </div>
            ) : null}
          </Form.Group>

          <Form.Group className="col-xl-3 col-lg-3 col-sm-12">
            <Form.Label className="col-12">{formFields["provincia"].label}</Form.Label>
            <Form.Control
              type="text"
              name="provincia"
              placeholder={formFields["provincia"].placeholder}
              className={getInputClasses("provincia")}
              {...formik.getFieldProps("provincia")}
            />
            {formik.touched["provincia"] && formik.errors["provincia"] ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors["provincia"]}</div>
              </div>
            ) : null}
          </Form.Group>

          <Form.Group className="col-xl-3 col-lg-6 col-sm-12">
            <Form.Label className="col-12">{formFields["recapito"].label}</Form.Label>
            <Form.Control
              type="text"
              name="recapito"
              placeholder={formFields["recapito"].placeholder}
              className={getInputClasses("recapito")}
              {...formik.getFieldProps("recapito")}
            />
            {formik.touched["recapito"] && formik.errors["recapito"] ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors["recapito"]}</div>
              </div>
            ) : null}
          </Form.Group>




          {/* <Form.Control
              type="hidden"
              name="idAgentePrev"
              placeholder={formFields["idAgentePrev"].placeholder}
              className={getInputClasses("idAgentePrev")}
              {...formik.getFieldProps("idAgentePrev")}
            /> */}
        </Form>
      </Card.Body>
    </Card>
  );
};
